import { ParsedQs } from 'qs';

import {
    PaginationMetaResource,
    StrapiDateData,
    StrapiEntity,
    StrapiEntityData,
    StrapiMeta,
} from '../@api/Strapi';
import { Block, BlockResource } from '../Block/Block';
import { AppRoute } from '../Routing/Routing';
import { Seo, SeoResource } from '../Seo/Seo';

export enum PageType {
    account = 'Account (klantomgeving)',
    brandDetail = 'Merk detail pagina (onder producten)',
    brandOverview = 'Merken',
    checkout = 'Checkout',
    cart = 'Winkelwagen',
    checkoutThankYou = 'Bedanktpagina',
    companyInspiration = 'Inspiratie',
    companyJoinUs = 'Deelnemen bij Loods 5',
    companyMedia = 'Media & PR',
    companyStory = 'Ons verhaal',
    companySustainability = 'Duurzaamheid',
    customerService = 'Contact',
    customerServiceAccount = 'Account (klantenservice)',
    customerServiceDelivery = 'Bezorging levertijden',
    customerServiceFaq = 'Veelgestelde vragen',
    customerServiceOrdering = 'Bestellingen betalen',
    customerServiceReturns = 'Ruilen retouren',
    customerServiceTerms = 'Winkelvoorwaarden',
    requestResetPassword = 'Wachtwoord herstellen aanvragen',
    resetPassword = 'Wachtwoord herstellen',
    giftcardBalance = 'Cadeaukaart',
    home = 'Home',
    login = 'Login',
    legalCookies = 'Cookiebeleid',
    legalDisclaimer = 'Disclaimer',
    legalPrivacy = 'Privacy',
    newsletter = 'Nieuwsbrief',
    ownCollection = 'Eigen collectie',
    orderDetail = 'Bestelling',
    productDetailPage = 'Product detail pagina (PDP)',
    products = 'Producten',
    registration = 'Registratie',
    sale = 'Sale',
    search = 'Geen resultaten bij het zoeken',
    spacesOverview = 'Ruimtes',
    storeOverview = 'Winkels',
    departmentOverview = 'Afdelingen',
    restaurant = 'Restaurant',
}

export const appRoutePageTypes: Partial<Record<AppRoute, PageType>> = {
    [AppRoute.account]: PageType.account,
    [AppRoute.accountOrderDetail]: PageType.orderDetail,
    [AppRoute.brandDetail]: PageType.brandDetail,
    [AppRoute.brandOverview]: PageType.brandOverview,
    [AppRoute.blogOverview]: PageType.companyInspiration,
    [AppRoute.checkoutOrder]: PageType.cart,
    [AppRoute.checkoutThankYou]: PageType.checkoutThankYou,
    [AppRoute.companyJoinUs]: PageType.companyJoinUs,
    [AppRoute.companyMedia]: PageType.companyMedia,
    [AppRoute.companyStory]: PageType.companyStory,
    [AppRoute.companySustainability]: PageType.companySustainability,
    [AppRoute.customerService]: PageType.customerService,
    [AppRoute.customerServiceAccount]: PageType.customerServiceAccount,
    [AppRoute.customerServiceDelivery]: PageType.customerServiceDelivery,
    [AppRoute.customerServiceFaq]: PageType.customerServiceFaq,
    [AppRoute.customerServiceOrdering]: PageType.customerServiceOrdering,
    [AppRoute.customerServiceReturns]: PageType.customerServiceReturns,
    [AppRoute.customerServiceTerms]: PageType.customerServiceTerms,
    [AppRoute.requestResetPassword]: PageType.requestResetPassword,
    [AppRoute.resetPassword]: PageType.resetPassword,
    [AppRoute.giftcardBalance]: PageType.giftcardBalance,
    [AppRoute.home]: PageType.home,
    [AppRoute.login]: PageType.login,
    [AppRoute.legalCookies]: PageType.legalCookies,
    [AppRoute.legalDisclaimer]: PageType.legalDisclaimer,
    [AppRoute.legalPrivacy]: PageType.legalPrivacy,
    [AppRoute.newsletter]: PageType.newsletter,
    [AppRoute.ownCollection]: PageType.ownCollection,
    [AppRoute.products]: PageType.products,
    [AppRoute.productDetail]: PageType.productDetailPage,
    [AppRoute.registration]: PageType.registration,
    [AppRoute.sale]: PageType.sale,
    [AppRoute.search]: PageType.search,
    [AppRoute.spacesOverview]: PageType.spacesOverview,
    [AppRoute.departmentOverview]: PageType.departmentOverview,
    [AppRoute.storeOverview]: PageType.storeOverview,
    [AppRoute.restaurant]: PageType.restaurant,
};

export interface PageResource extends StrapiEntityData, StrapiDateData {
    title: string;
    slug: string;
    description: string | null;
    elements: BlockResource[];
    seo?: SeoResource;
}

export type PageResponse = StrapiEntity<PageResource[]> & StrapiMeta<PaginationMetaResource>;

export interface PageInterface {
    id: string;
    title: string;
    description: string;
    blocks: Block[];
    seo?: Seo;
}

export interface PageConfig {
    appRoute: AppRoute;
    queryParams?: ParsedQs;
}

export interface CustomPageConfig {
    slug: string;
    queryParams?: ParsedQs;
}

export interface PageDraftConfig {
    status?: string;
    previewKey?: string;
}
